import { tryCatchHelper } from '../../../helpers';
import { oneDocentesAction } from '../../control_estudios/docentes/DocentesAction';
import {
  ACTIVO_ENT_CARRERAS,
  ALL_ENT_CARRERAS,
  LOADING_ALL_ENT_CARRERAS,
} from './EntCarrerasReducer';
import {
  allEntCarrerasService,
  asignarEntCarDocentesService,
  deleteEntCarDocentesService,
  deleteEntCarrerasService,
  oneEntCarrerasService,
  saveEntCarrerasService,
} from './EntCarrerasService';

export const allEntCarrerasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ENT_CARRERAS, payload: true });
    const res = await allEntCarrerasService(params);
    dispatch({ type: ALL_ENT_CARRERAS, payload: res.data });
    dispatch({ type: LOADING_ALL_ENT_CARRERAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ENT_CARRERAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEntCarrerasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEntCarrerasService(id, data);
    notify(res.data.message);
    await allEntCarrerasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEntCarrerasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ENT_CARRERAS, payload: data });
};

export const oneEntCarrerasAction = async (dispatch, id) => {
  try {
    const res = await oneEntCarrerasService(id);
    await setActivoEntCarrerasAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEntCarrerasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEntCarrerasService(id);
    await setActivoEntCarrerasAction(dispatch, null);
    notify(res.data.message);
    await allEntCarrerasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const asignarEntCarDocentesAction = async (
  { dispatch, notify },
  data,
) => {
  try {
    const res = await asignarEntCarDocentesService(data);
    notify(res.data.message);
    await oneDocentesAction(dispatch, data.idDocente);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const deleteEntCarDocentesAction = async (
  { dispatch, notify },
  id,
  idDocente,
) => {
  try {
    const res = await deleteEntCarDocentesService(id);
    await oneDocentesAction(dispatch, idDocente);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
